import React from "react";
import Sidebar from "../../components/SidebarNew/Sidebar";
import Navbar from "../../components/NavbarProfile/NavbarProfile";
import PackageDetails from "../../components/Dashboard/PackageDetails";
import "../PRmanager/PR.css";

export default function PackageDetailsPage() {
    const activeSide = 1;
    return (
        <>
            <div className="dashboard_container row gx-0 pr_manager_layout">
                <Sidebar activeSide={activeSide} />
                <div className={`main col`}>
                    <Navbar name={"Package Details"} />
                    <PackageDetails />
                </div>
            </div>
        </>
    );
}
